<template>
    <b-modal ref="mdlNuovaAnagrafica" size="xl" :title="titoloModal" style="height: 100%" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="sa-tab-scroll">
            <b-card v-if="step === 0" class="sa-card sa-card-border" header="" header-tag="header" footer-tag="footer" title="">
                <!-- <div class="sa-tab-scroll"> -->
                <b-card class="sa-card" header="Testata" header-tag="header" footer-tag="footer" title="">
                    <template #header>
                        <b-row>
                            <b-col cols="12" xs="9" sm="9" md="9" lg="9" xl="9">
                                <span>TESTATA</span>
                            </b-col>
                            <b-col cols="12" xs="3" sm="3" md="3" lg="3" xl="3" class="sa-padding-right text-right">
                                <b-button variant="outline-success outline-secondary-success pull-right" size="sm" @click="onClickSearchAnagrafica">
                                    <i style="margin-top: 2px" class="fas fa-search"></i>
                                    <span style="padding-left: 5px">CERCA</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Intestatario:</label>
                            <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                            <span class="sa-data">{{ jsonData.anagrafica.codice }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Nominativo Intestatario:</label>
                            <span class="sa-data">{{ jsonData.anagrafica.nominativo }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale:</label>
                            <span class="sa-data">{{ jsonData.anagrafica.codiceFiscale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">P. Iva:</label>
                            <span class="sa-data">{{ jsonData.anagrafica.partitaIva }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Citta:</label>
                            <span class="sa-data">{{ jsonData.anagrafica.citta }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Indirizzo:</label>
                            <span class="sa-data">{{ jsonData.anagrafica.indirizzo }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">N. Documento Origine:</label>
                            <b-form-input v-model="jsonData.documentoOrigine" placeholder="N. Documento Origine"></b-form-input>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                            <label class="sa-label-data">Attivo</label>
                        </b-form-checkbox>
                    </b-col>
                </b-row> -->
                </b-card>
                <b-card class="sa-card" header="Righe" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaRighe" :fields="fields" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light">
                                <template #cell(index)="row">
                                    {{ row.index + 1 }}
                                </template>
                                <template #cell(descrizioneArticolo)="row">
                                    <b-input-group-append>
                                        <b-form-input v-model="row.item.descrizioneArticolo" placeholder="Articolo" disabled></b-form-input>
                                        <b-button v-if="row.index === jsonData.listaRighe.length - 1" @click="onSearchArticolo(row.item)"><b-icon icon="search"></b-icon></b-button>
                                    </b-input-group-append>
                                </template>
                                <template #cell(quantita)="row">
                                    <b-form-input v-model="row.item.quantita" placeholder="Quantita" type="number" step="1" @input="onChangeAliquota(row.item, row.index !== jsonData.listaRighe.length - 1)"></b-form-input>
                                </template>
                                <template #cell(prezzoUnitario)="row">
                                    <b-form-input v-model="row.item.prezzoUnitario" placeholder="Prezzo" type="number" step="0.1" @input="onChangeAliquota(row.item, row.index !== jsonData.listaRighe.length - 1)"></b-form-input>
                                </template>
                                <template #cell(aliquotaIvaDescrizione)="row">
                                    <b-form-select v-model="row.item.aliquotaIvaDescrizione" :options="ivaOptions" :value="null" value-field="value" text-field="text" @change="onChangeAliquota(row.item, row.index !== jsonData.listaRighe.length - 1)"> </b-form-select>
                                    <!-- <b-form-input v-model="item.item.aliquotaIva" placeholder="Aliquota Iva" disabled></b-form-input> -->
                                </template>
                                <template #cell(aliquotaIva)="item">
                                    <b-form-input v-model="item.item.aliquotaIva" placeholder="Aliquota Iva" disabled></b-form-input>
                                </template>
                                <template #cell(offerta)="item">
                                    <!-- <b-form-input v-model="item.item.offerta" placeholder="Offerta"></b-form-input> -->
                                    <b-form-select v-model="item.item.offerta" :options="siNoOption" :value="''" value-field="value" text-field="text"> </b-form-select>
                                </template>
                                <template #cell(actions)="row">
                                    <b-button v-if="row.index === jsonData.listaRighe.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAdd(jsonData.listaRighe, row.item)">
                                        <b-icon icon="plus"></b-icon>
                                    </b-button>
                                    <b-button v-if="row.index !== jsonData.listaRighe.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(jsonData.listaRighe, row)">
                                        <b-icon icon="trash"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="sa-card" header="Totali" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Importo Lordo:</label>
                            <b-form-input v-model="jsonData.importoLordo" disabled></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Importo Netto:</label>
                            <b-form-input v-model="jsonData.importoNetto" disabled></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Importo Iva:</label>
                            <b-form-input v-model="jsonData.importoIva" disabled></b-form-input>
                        </b-col>
                    </b-row>
                </b-card>
                <modal-error ref="cmpModalError"></modal-error>
                <!-- </div> -->
            </b-card>
            <b-card v-if="step === 1" class="sa-card sa-card-border" header="" header-tag="header" footer-tag="footer" title="">
                <!-- <div class="sa-tab-scroll"> -->
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-form @submit.prevent="onSubmitAnAgrafica">
                            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                                <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Codice Articolo:</label>
                                    <b-form-input v-model="filtroArticoli.codice" type="search" id="codice" placeholder="Codice"></b-form-input>
                                </b-col>
                                <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Barcode:</label>
                                    <b-form-input v-model="filtroArticoli.barcode" type="search" id="barcode" placeholder="Barcode"></b-form-input>
                                </b-col>
                                <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Descrizione Articolo:</label>
                                    <b-form-input v-model="filtroArticoli.descrizione" type="search" id="descrizione" placeholder="Descrizione Articolo"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                                    <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                                    <b-button type="reset" v-on:click="onResetAgrafica" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-col>
                    <!-- <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> -->

                    <!-- </div> -->
                    <!-- </b-col> -->
                </b-row>
                <b-row class="sa-label-info">
                    <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                        <p>Record Totali: {{ rowsAnagrafica }}</p>
                    </b-col>
                    <b-col xs="9" sm="9" md="9" lg="9" xl="9">
                        <b-pagination v-model="currentPageAnagrafica" :total-rows="rowsAnagrafica" :per-page="perPageAnagrafica" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
                <!-- <div class="sa-tab-scroll"> -->
                <b-table sticky-header ref="tblMalattie" stacked="sm" striped hover :items="articoliOptions" :fields="fieldsArticoli" :current-page="1" :per-page="perPageAnagrafica" sort-icon-left head-variant="light" class="sa-b-table" selectable select-mode="single" @row-selected="onRowSelectedArticolo" thead-class="hidden-header" @row-dblclicked="onRowDblClickedArticoli">
                    <template #cell(selezionato)="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selezionato</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Non Selezionato</span>
                        </template>
                    </template>
                </b-table>
                <!-- </div> -->
            </b-card>
            <b-card v-if="step === 2" class="sa-card sa-card-border" header="" header-tag="header" footer-tag="footer" title="">
                <!-- <div class="sa-form-section"> -->
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-form @submit.prevent="onSubmit">
                            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Nominativo:</label>
                                    <b-form-input v-model="filtro.nominativo" type="search" id="nominativo" placeholder="Nominativo"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">P. Iva:</label>
                                    <b-form-input v-model="filtro.partitaIva" type="search" id="partitaIva" placeholder="P. Iva"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Codice Fiscale:</label>
                                    <b-form-input v-model="filtro.codiceFiscale" type="search" id="codiceFiscale" placeholder="Codice Fiscale"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                                    <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                                    <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row class="sa-label-info">
                            <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                                <p>Record Totali: {{ rowsClienti }}</p>
                            </b-col>
                            <b-col xs="9" sm="9" md="9" lg="9" xl="9">
                                <b-pagination v-model="currentPageClienti" :total-rows="rowsClienti" :per-page="perPageClienti" align="right" size="sm"></b-pagination>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="tblMalattie" stacked="xl" striped hover itemscope :items="fornitoriOptions" :fields="fieldsAnagrafica" :current-page="1" :per-page="perPageClienti" sort-icon-left head-variant="light" class="sa-b-table" selectable select-mode="single" @row-selected="onRowSelectedAnagrafica" @row-dblclicked="onRowDblClicked">
                                <template v-slot:cell(codiceIcdix)="{ item }">
                                    <template v-if="item.entroOre !== null && item.entroOre !== ''">
                                        <label class="sa-label-data">{{ item.codiceIcdix }}</label>
                                    </template>
                                    <template v-else>
                                        {{ item.codiceIcdix }}
                                    </template>
                                </template>
                                <template v-slot:cell(descrizioneIcdix)="{ item }">
                                    <template v-if="item.entroOre !== null && item.entroOre !== ''">
                                        <label class="sa-label-data">{{ item.descrizioneIcdix }}</label>
                                    </template>
                                    <template v-else>
                                        {{ item.descrizioneIcdix }}
                                    </template>
                                </template>
                                <template v-slot:cell(entroOre)="{ item }">
                                    <template v-if="item.entroOre !== null && item.entroOre !== ''">
                                        <label class="sa-label-data">{{ item.entroOre }}</label>
                                    </template>
                                    <template v-else>
                                        {{ item.entroOre }}
                                    </template>
                                </template>
                                <template #cell(selezionato)="{ rowSelected }">
                                    <template v-if="rowSelected">
                                        <span aria-hidden="true">&check;</span>
                                        <span class="sr-only">Selezionato</span>
                                    </template>
                                    <template v-else>
                                        <span aria-hidden="true">&nbsp;</span>
                                        <span class="sr-only">Non Selezionato</span>
                                    </template>
                                </template>
                            </b-table>
                        </div>
                    </b-col>
                </b-row>
                <!-- </div> -->
                <!-- </div> -->
            </b-card>
        </div>
        <template #modal-footer>
            <b-button v-if="step === 0" variant="outline-success" @click="onClickOk">Salva</b-button>
            <b-button v-if="step === 0" variant="outline-warning" @click="onClickSalvaBozza"> Salva Bozza </b-button>
            <b-button v-if="step === 0" variant="outline-danger" @click="onClose">Annulla</b-button>
            <b-button v-if="step > 0" variant="outline-danger" @click="onClickIndietro">Annulla</b-button>
            <b-button v-if="step === 1" variant="outline-success" @click="onClickSelezionaArticolo">Seleziona</b-button>
            <b-button v-if="step === 2" variant="outline-success" @click="onClickSeleziona">Seleziona</b-button>
            <!--@click="$refs.mdlRsaSchedaPsicologica.hide()" -->
        </template>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            pathResource: "/documenti",
            pathFornitori: "/anagrafica",
            pathIva: "/iva",
            pathGruppi: "/articoligruppi",
            pathArticoli: "/articoli",
            pathMarche: "/marche",
            pathUnitaMisura: "/unitamisura",
            pathDepositi: "/depositi",
            pathResourceTipiAnagrafica: "/dizionariotipi",
            nuovo: false,
            step: 0,
            currentPageAnagrafica: 1,
            perPageAnagrafica: 10,
            rowsAnagrafica: 0,
            currentPageClienti: 1,
            perPageClienti: 10,
            rowsClienti: 0,
            filtro: { nominativo: "", codiceTipo: "", partitaIva: "", codiceFiscale: "" },
            filtroArticoli: {},
            anagraficaSelezionata: {},
            articoloSelezionato: {},
            titoloModal: "",
            nomeDocumento: "",
            fornitoriOptions: [],
            rigaSelezionata: {},
            ivaOptions: [],
            ivaList: [],
            gruppiOptions: [],
            marcheOptions: [],
            unitaMisuraOptions: [],
            depositiOptions: [],
            tipoAnagraficaOptions: [],
            articoliOptions: [],
            jsonData: {
                tipo: "",
                dataOra: null,
                importoNetto: 0.0,
                importoNettoAggiuntivo: 0.0,
                importoIva: 0.0,
                importoLordo: 0.0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [{ aliquotaIvaDescrizione: null }],
                anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
            },
            siNoOption: [
                { value: "", text: "-Seleziona Valore-" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
            fieldsArticoli: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Codice",
                    key: "codice",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Fornitore",
                    key: "descrizioneFornitore",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "I.V.A.",
                    key: "descrizioneIva",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                // {
                //     label: "Città",
                //     key: "citta",
                //     // thStyle: "width: 5rem",
                //     sortable: true,
                // },
                // {
                //     label: "Indirizzo",
                //     key: "indirizzo",
                //     // thStyle: "width: 5rem",
                //     sortable: true,
                // },
                {
                    label: "Attivo",
                    key: "attivo",
                    thStyle: "width: 7rem",
                    sortable: true,
                },
            ],
            fieldsAnagrafica: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                // {
                //     label: "Tipo",
                //     key: "descrizioneTipo",
                //     // thStyle: "width: 5rem",
                //     sortable: true,
                // },
                {
                    label: "Nominativo",
                    key: "nominativo",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Codice Fiscale",
                    key: "codiceFiscale",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "P. Iva",
                    key: "partitaIva",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Città",
                    key: "citta",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Indirizzo",
                    key: "indirizzo",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizioneArticolo",
                    // thStyle: "width: 20rem",
                    // sortable: true,
                },
                {
                    label: "Q.ta",
                    key: "quantita",
                    thStyle: "width: 8rem",
                    // sortable: true,
                },
                {
                    label: "P.zo Un.",
                    key: "prezzoUnitario",
                    thStyle: "width: 8rem",
                    // sortable: true,
                },
                {
                    label: "Iva (%)",
                    key: "aliquotaIvaDescrizione",
                    thStyle: "width: 15rem",
                    // sortable: true,
                },
                // {
                //     label: "Iva",
                //     key: "aliquotaIva",
                //     thStyle: "width: 5rem",
                //     // sortable: true,
                // },
                // {
                //     label: "Offerta",
                //     key: "offerta",
                //     // thStyle: "width: 15rem",
                //     // sortable: true,
                // },
                { class: "sa-table-column-action-double", key: "actions", label: "", thStyle: "width: 5rem" },
            ],
        };
    },
    watch: {
        currentPageAnagrafica() {
            let me = this;
            me.loadArticoli();
        },
        currentPageClienti() {
            let me = this;
            me.loadFornitori();
        },
    },
    methods: {
        onRowDblClicked() {
            let me = this;
            me.jsonData.anagrafica.codice = me.anagraficaSelezionata.codice;
            me.jsonData.anagrafica = me.anagraficaSelezionata;
            me.jsonData.idAnagrafica = me.anagraficaSelezionata.id;
            me.jsonData.descrizioneAnagrafica = me.anagraficaSelezionata.nominativo;
            me.step = 0;
        },
        onClickSeleziona() {
            let me = this;
            me.jsonData.anagrafica.codice = me.anagraficaSelezionata.codice;
            me.jsonData.anagrafica = me.anagraficaSelezionata;
            me.jsonData.idAnagrafica = me.anagraficaSelezionata.id;
            me.jsonData.descrizioneAnagrafica = me.anagraficaSelezionata.nominativo;
            me.step = 0;
        },
        onChangeAliquota(item, noUltimaRiga) {
            let me = this;
            me.ivaList.forEach((element) => {
                if (item.aliquotaIvaDescrizione === element.codice) {
                    item.aliquotaIva = element.aliquota;
                }
            });
            if (noUltimaRiga) {
                me.calcolaTotali();
            }
        },
        onSubmit() {
            let me = this;
            me.loadFornitori();
        },
        onSubmitAnAgrafica() {
            let me = this;
            me.loadArticoli();
        },
        onRowSelectedArticolo(rows) {
            let me = this;
            // console.log(rows[0]);

            if (rows[0]) {
                me.articoloSelezionato = rows[0];
            }
            // console.log(me.rigaSelezionata);
        },
        onRowDblClickedArticoli() {
            let me = this;
            me.rigaSelezionata.descrizioneArticolo = me.articoloSelezionato.descrizione;
            me.rigaSelezionata.idArticolo = me.articoloSelezionato.id;
            me.rigaSelezionata.aliquotaIva = me.articoloSelezionato.aliquotaIva;
            me.rigaSelezionata.aliquotaIvaDescrizione = me.articoloSelezionato.descrizioneIva;
            me.step = 0;
        },
        onClickSelezionaArticolo() {
            let me = this;
            me.rigaSelezionata.descrizioneArticolo = me.articoloSelezionato.descrizione;
            me.rigaSelezionata.idArticolo = me.articoloSelezionato.id;
            me.rigaSelezionata.aliquotaIva = me.articoloSelezionato.aliquotaIva;
            me.rigaSelezionata.aliquotaIvaDescrizione = me.articoloSelezionato.descrizioneIva;
            me.step = 0;
        },
        onRowSelectedAnagrafica(rows) {
            let me = this;
            if (rows[0]) {
                me.anagraficaSelezionata = rows[0];

                // me.changeFornitore();
            }
        },
        changeFornitore() {
            let me = this;
            me.jsonData.anagrafica = {};
            me.jsonData.idAnagrafica = null;
            me.jsonData.descrizioneAnagrafica = null;
            me.fornitoriOptions.forEach((element) => {
                if (element.codice === me.jsonData.anagrafica.codice) {
                    me.jsonData.anagrafica = element;
                    me.jsonData.idAnagrafica = element.id;
                    me.jsonData.descrizioneAnagrafica = element.nominativo;
                }
            });
        },
        onReset() {
            let me = this;
            me.filtro = { nome: null, cognome: null, identificativo: null };
            me.filtro.codiceFiltro = me.codiceFiltro;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadFornitori();
        },
        onResetAgrafica() {
            let me = this;
            me.filtroArticoli = {};
            // me.filtro.codiceFiltro = me.codiceFiltro;
            // let sessionStorage = window.sessionStorage;
            // sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadArticoli();
        },
        onClickSearchAnagrafica() {
            let me = this;
            me.loadFornitori();
        },
        onSearchArticolo(riga) {
            let me = this;
            me.step = 1;
            me.rigaSelezionata = riga;
            me.loadArticoli();
        },
        onClickIndietro() {
            let me = this;
            me.step = 0;
        },
        openModal(item, documento) {
            let me = this;
            me.nomeDocumento = documento;
            let codice = this.$route.query.codiceTipo;
            me.$emit("beforloadData");
            if (item !== null) {
                me.nuovo = false;
                me.titoloModal = "Modifica Documento " + me.nomeDocumento;
                // me.jsonData = item;
                me.loadData(item.id);
            } else {
                me.nuovo = true;
                me.titoloModal = "Aggiungi Documento " + me.nomeDocumento;
                me.jsonData = {
                    tipo: codice,
                    dataOra: null,
                    importoNetto: 0,
                    importoNettoAggiuntivo: 0,
                    importoIva: 0,
                    importoLordo: 0,
                    statoAttuale: "",
                    statoAttualeDataOra: null,
                    idAnagrafica: "",
                    listaRighe: [],
                    anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
                };
                me.jsonData.listaRighe.push({ aliquotaIvaDescrizione: null, aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
            }

            me.loadIva();
            me.loadGruppi();
            me.loadMarche();
            me.loadUnitaMisura();
            me.loadDepositi();
            me.$refs.mdlNuovaAnagrafica.show();
            me.$emit("afterLoadData");
        },
        loadData(id) {
            let me = this;

            let path = "";
            let tipo = this.$route.query.tipo;
            if (tipo === "A") {
                path = me.pathResource + "/a";
            } else {
                path = me.pathResource;
            }
            let link = process.env.VUE_APP_PATH_API + path + "/" + id;
            UtilityMixin.methods.restCallGet(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$emit("afterLoadData");
            me.jsonData.listaRighe.push({ aliquotaIvaDescrizione: null, aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
        },
        loadDataError(response) {
            console.log(response);
            this.$emit("afterLoadData");
        },
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "DOCUMENTO";
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadTipiAnagraficaSuccess, me.loadTipiAnagraficaError);
        },
        loadTipiAnagraficaSuccess(response) {
            let me = this;
            me.tipoAnagraficaOptions = response.data.data.list;
            me.tipoAnagraficaOptions.unshift({ codice: null, nominativo: "-Seleziona Valore-" });
        },
        loadTipiAnagraficaError(response) {
            console.log(response);
        },
        loadFornitori() {
            let me = this;
            // let filtro = { codiceTipo: "ALL" };
            me.filtro.codiceTipo = "ALL";
            me.filtro.page = me.currentPageClienti;
            me.filtro.forPage = me.perPageClienti;
            UtilityMixin.methods.loadDataResources(me.pathFornitori, me.filtro, me.loadFornitoriSuccess, me.loadFornitoriError);
        },
        loadFornitoriSuccess(response) {
            let me = this;
            me.rowsClienti = response.data.data.recordsNumber;
            me.fornitoriOptions = response.data.data.list;
            me.step = 2;
            // me.fornitoriOptions.unshift({ codice: null, nominativo: "-Seleziona Valore-" });
        },
        loadFornitoriError(response) {
            console.log(response);
        },
        loadArticoli() {
            let me = this;
            // let filtro = {};
            me.filtroArticoli.page = me.currentPageAnagrafica;
            me.filtroArticoli.forPage = me.perPageAnagrafica;
            UtilityMixin.methods.loadDataResources(me.pathArticoli, me.filtroArticoli, me.loadArticoliSuccess, me.loadArticoliError);
        },
        loadArticoliSuccess(response) {
            let me = this;
            me.rowsAnagrafica = response.data.data.recordsNumber;
            me.articoliOptions = response.data.data.list;
            // me.articoliOptions.unshift({ codice: "", descrizione: "-Seleziona Valore-" });
        },
        loadArticoliError(response) {
            console.log(response);
        },
        loadIva() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathIva, null, me.loadIvaSuccess, me.loadIvaError);
        },
        loadIvaSuccess(response) {
            let me = this;
            me.ivaList = response.data.data.list;
            me.ivaOptions = [];
            response.data.data.list.forEach((element) => {
                this.ivaOptions.push({ value: element.codice, text: element.codice });
            }),
                me.ivaOptions.unshift({ value: null, text: "-Seleziona Valore-" });
        },
        loadIvaError(response) {
            console.log(response);
        },
        loadGruppi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathGruppi, null, me.loadGruppiSuccess, me.loadGruppiError);
        },
        loadGruppiSuccess(response) {
            let me = this;
            me.gruppiOptions = response.data.data.list;
            me.gruppiOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadGruppiError(response) {
            console.log(response);
        },
        loadMarche() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathMarche, null, me.loadMarcheSuccess, me.loadMarcheError);
        },
        loadMarcheSuccess(response) {
            let me = this;
            me.marcheOptions = [];
            response.data.data.list.forEach((element) => {
                me.marcheOptions.push({ value: element.descrizone, text: element.descrizone });
            }),
                me.marcheOptions.unshift({ value: null, text: "-Seleziona Valore-" });
        },
        loadMarcheError(response) {
            console.log(response);
        },
        loadUnitaMisura() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathUnitaMisura, null, me.loadUnitaMisuraSuccess, me.loadUnitaMisuraError);
        },
        loadUnitaMisuraSuccess(response) {
            let me = this;
            me.unitaMisuraOptions = response.data.data.list;
            me.unitaMisuraOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadUnitaMisuraError(response) {
            console.log(response);
        },
        loadDepositi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathDepositi, null, me.loadDepositiSuccess, me.loadDepositiError);
        },
        loadDepositiSuccess(response) {
            let me = this;
            me.depositiOptions = response.data.data.list;
            me.depositiOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadDepositiError(response) {
            console.log(response);
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = {
                tipo: null,
                dataOra: null,
                importoNetto: 0,
                importoNettoAggiuntivo: 0,
                importoIva: 0,
                importoLordo: 0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [],
            };
            me.$emit("afterLoadData");
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            me.jsonData.statoAttuale = "COMPLETA";
            let tipo = this.$route.query.tipo;
            let path = "";
            if (tipo === "A") {
                path = me.pathResource + "/a";
            } else {
                path = me.pathResource;
            }
            UtilityMixin.methods.saveResource(path, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        calcolaTotali() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/elabora";
            UtilityMixin.methods.restCallPost(path, me.jsonData, this.calcolaTotaliSuccessResponse, this.calcolaTotaliErrorResponse);
        },
        onClickSalvaBozza(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            me.jsonData.statoAttuale = "BOZZA";
            let tipo = this.$route.query.tipo;
            let path = "";
            if (tipo === "A") {
                path = me.pathResource + "/a";
            } else {
                path = me.pathResource;
            }
            UtilityMixin.methods.saveResource(path, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaAnagrafica.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
        calcolaTotaliSuccessResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            // me.jsonData.listaRighe.push({ aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
        },

        calcolaTotaliErrorResponse(error) {
            console.log(error);
        },
        onChangeFornitore() {
            let me = this;
            me.fornitoriOptions.forEach((element) => {
                if (element.codice === me.jsonData.anagrafica.codice) {
                    me.jsonData.anagrafica = element;
                    me.jsonData.idAnagrafica = element.id;
                }
            });
        },
        onChangeArticolo(item) {
            let me = this;
            me.articoliOptions.forEach((element) => {
                if (element.descrizione === item.descrizioneArticolo) {
                    item.idArticolo = element.id;
                    item.aliquotaIva = element.aliquotaIva;
                }
            });
        },
        onChangeIva() {
            let me = this;
            me.ivaList.forEach((element) => {
                if (element.codice === me.jsonData.codiceIva) {
                    me.jsonData.descrizioneIva = element.descrizione;
                    me.jsonData.aliquotaIva = element.aliquota;
                }
            });
        },
        onAdd(array, value) {
            if (value.descrizioneArticolo && value.aliquotaIvaDescrizione !== null && value.quantita > 0 && value.quantita > 0) {
                // value.quantita = value.quantita.replace(",", ".");
                // value.prezzoUnitario = value.prezzoUnitario.replace(",", ".");
                // console.log(value);
                array.push({ aliquotaIvaDescrizione: null, aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
                this.calcolaTotali();
            } else {
                this.$bvModal
                    .msgBoxOk("Riga non completa devono essere compilate Deescrizione, Quantità, Prezzo Unitario e Iva", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then(() => {
                        // console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDelete(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                            this.calcolaTotali();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onClose() {
            let me = this;
            me.$refs.mdlNuovaAnagrafica.hide();
            me.jsonData = {
                tipo: null,
                dataOra: null,
                importoNetto: 0,
                importoNettoAggiuntivo: 0,
                importoIva: 0,
                importoLordo: 0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [],
                anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
            };
        },
    },
};
</script>
<style scoped>
.btn-outline-warning {
    color: #ff6a07;
    border-color: #ff6a07;
}

.btn-outline-warning:hover {
    color: #fff;
    background-color: #ff6a07;
    border-color: #ff6a07;
}

.btn-outline-warning.focus,
.btn-outline-warning:focus {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
    color: #ff6a07;
    background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active,
.show > .btn-outline-warning.dropdown-toggle {
    color: #1f2d3d;
    background-color: #ff6a07;
    border-color: #ff6a07;
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5);
}
</style>
